import { useQuery } from '@zg-rentals/react-query5';
import { getUserListings } from '@/src/lib/api/endpoints/user';
import type { UserListingType } from '@/src/lib/api/endpoints/user';
import type { SummaryListingDetails } from '@/src/types/summaryListingDetails.type';
import { USER_LISTINGS_TAG } from './queryTags';

import { userListingKeys } from './queryKeys';

export type UserListingsData = {
  listings: Array<SummaryListingDetails>;
  totalCount: number;
};

export function useUserListings(type: UserListingType, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: userListingKeys.byType(type),
    queryFn: async () => {
      const response = await getUserListings(type);
      const listings = (response.buildings ?? []).flatMap(
        (building) => (building.listings ?? []) as Array<SummaryListingDetails>,
      );
      return { listings, totalCount: response.totalCount ?? listings.length };
    },
    enabled: options?.enabled !== false,
    staleTime: 0,
    meta: {
      tags: [USER_LISTINGS_TAG],
      context: {
        api: 'hotpads-api',
        details: `fetch ${type} user listings`,
      },
    },
  });
}
